/**
 * App-wide scrollbar: edit NICE_SCROLLBAR_SETTINGS only.
 * Applied globally (App.js GlobalStyles + scrollListSx on scroll regions).
 */

export const NICE_SCROLLBAR_SETTINGS = {
  colors: {
    track: "#00000000",
    thumb: "#798494",
    thumbHover: "#5a626e",
    corner: "transparent",
  },
  size: {
    width: "5px",
    height: "5px",
  },
  radius: "8px",
  thumbMinHeight: "16px",
  firefoxWidth: "thin",
};

const S = NICE_SCROLLBAR_SETTINGS;

const VAR = "app-scrollbar";

export const scrollbarCssVars = {
  [`--${VAR}-track`]: S.colors.track,
  [`--${VAR}-thumb`]: S.colors.thumb,
  [`--${VAR}-thumb-hover`]: S.colors.thumbHover,
  [`--${VAR}-corner`]: S.colors.corner,
  [`--${VAR}-width`]: S.size.width,
  [`--${VAR}-height`]: S.size.height,
  [`--${VAR}-radius`]: S.radius,
  [`--${VAR}-thumb-min-height`]: S.thumbMinHeight,
  [`--${VAR}-firefox-width`]: S.firefoxWidth,
};

const firefoxScrollbar = {
  scrollbarWidth: S.firefoxWidth,
  scrollbarColor: `${S.colors.thumb} ${S.colors.track}`,
};

const webkitScrollbar = {
  width: S.size.width,
  height: S.size.height,
  background: S.colors.track,
  borderRadius: S.radius,
};

const webkitScrollbarTrack = {
  background: S.colors.track,
  borderRadius: S.radius,
};

const webkitScrollbarThumb = {
  background: S.colors.thumb,
  borderRadius: S.radius,
  minHeight: S.thumbMinHeight,
  border: "none",
};

const webkitScrollbarThumbHover = {
  background: S.colors.thumbHover,
};

const webkitScrollbarButtonsHidden = {
  display: "none",
  width: 0,
  height: 0,
};

export const appScrollbarSx = {
  ...firefoxScrollbar,
  "&::-webkit-scrollbar": webkitScrollbar,
  "&::-webkit-scrollbar-button": webkitScrollbarButtonsHidden,
  "&::-webkit-scrollbar-button:start:decrement": webkitScrollbarButtonsHidden,
  "&::-webkit-scrollbar-button:end:increment": webkitScrollbarButtonsHidden,
  "&::-webkit-scrollbar-track": webkitScrollbarTrack,
  "&::-webkit-scrollbar-thumb": webkitScrollbarThumb,
  "&::-webkit-scrollbar-thumb:hover": webkitScrollbarThumbHover,
  "&::-webkit-scrollbar-corner": {
    background: S.colors.corner,
  },
};

export const globalScrollbarStyles = {
  ":root": scrollbarCssVars,
  html: firefoxScrollbar,
  body: firefoxScrollbar,
  "*": firefoxScrollbar,
  "::-webkit-scrollbar": webkitScrollbar,
  "::-webkit-scrollbar-button": webkitScrollbarButtonsHidden,
  "::-webkit-scrollbar-button:start:decrement": webkitScrollbarButtonsHidden,
  "::-webkit-scrollbar-button:end:increment": webkitScrollbarButtonsHidden,
  "::-webkit-scrollbar-track": webkitScrollbarTrack,
  "::-webkit-scrollbar-thumb": webkitScrollbarThumb,
  "::-webkit-scrollbar-thumb:hover": webkitScrollbarThumbHover,
  "::-webkit-scrollbar-corner": {
    background: S.colors.corner,
  },
};

export const scrollListSx = {
  overflowY: "auto",
  overflowX: "hidden",
  WebkitOverflowScrolling: "touch",
  ...appScrollbarSx,
};

export const scrollPanelSx = {
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  ...scrollListSx,
};
